import { FilterIcon } from "assets/icons";
import { If } from "components";
import { convertSearchParamsToObject } from "helpers";
import { useOnClickOutside } from "hooks";
import { useRef } from "react";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { Button } from "ui";

import { getAuditLogsFilterNewSearchParams } from "../../helpers";
import { FilterFormValues, AuditLogsFilterForm } from "../forms";
import { AuditLogsTableFilterProps } from "./AuditLogsTableFilter.types";

import styles from "./AuditLogsTableFilter.module.scss";

const AUDIT_LOGS_FILTER_FORM_ID = "audit-logs-filter-form-id";

const AuditLogsTableFilter = ({
  isLoading,
  isOpen,
  onClose,
  onToggle
}: AuditLogsTableFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const containerRef = useRef(null);
  useOnClickOutside(containerRef, onClose);

  const submitFilterForm = (body: FilterFormValues) => {
    const existingParams = convertSearchParamsToObject(searchParams);
    const newParams = getAuditLogsFilterNewSearchParams(body);

    setSearchParams(
      createSearchParams({
        ...existingParams,
        ...newParams,
        page: "1"
      })
    );

    onClose();
  };

  return (
    <div className={styles.filter} ref={containerRef}>
      <Button
        variant="primary"
        icon={<FilterIcon />}
        className={styles.filter__button}
        onClick={onToggle}
      />

      <If condition={isOpen}>
        <div className={styles.filter__content}>
          <AuditLogsFilterForm
            formId={AUDIT_LOGS_FILTER_FORM_ID}
            onSubmit={submitFilterForm}
            isLoading={isLoading}
          />
        </div>
      </If>
    </div>
  );
};

export default AuditLogsTableFilter;
